import ConfirmationPage from '../../shared/booking/ConfirmationPage';
import InsuranceSummary from './InsuranceSummary';
import InsurancePolicies from './InsurancePolicies';

export default function InsuranceConfirmation() {
  return (
    <ConfirmationPage
      module="insurance"
      Summary={InsuranceSummary}
      refLabel="Policy number"
      Extra={InsurancePolicies}
      nextSteps={[
        'Your policy document has been emailed — attach it to your visa application if needed.',
        'Carry a copy of the policy (printed or on your phone) while you travel.',
        'In a medical emergency, call the assistance number on your policy before visiting a hospital for cashless treatment.',
        'View your policies or cancel up to 24 hours before cover starts from My Trips.',
      ]}
    />
  );
}
